import { render, staticRenderFns } from "./SchemaLayout.vue?vue&type=template&id=0f829a24&scoped=true&"
import script from "./SchemaLayout.vue?vue&type=script&lang=js&"
export * from "./SchemaLayout.vue?vue&type=script&lang=js&"
import style0 from "./SchemaLayout.vue?vue&type=style&index=0&id=0f829a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f829a24",
  null
  
)

export default component.exports